<div class="listing-flags has-pos-abs">
  <span *ngIf="newOrUpdatedFlagType" class="flag new-or-updated" translate="{{'listing-flags.' + newOrUpdatedFlagType}}"></span>
  <span *ngIf="isExclusive" class="flag new-or-updated" translate="listing-flags.exclusive"></span>

  <span *ngIf="showOpenHouse" class="flag open-house" [class.luxury]="isLuxury" translate="listing-flags.open-house"></span>
</div>
